import styles from "./Skeleton.module.css";

interface SkeletonProps {
  variant?: "row" | "text" | "block";
  width?: number | string;
  height?: number | string;
}

/**
 * Skeleton — slow opacity pulse, no moving shimmer.
 *
 * Use `variant` for the common shapes; use explicit `width`/`height`
 * for anything else. If you find yourself passing both `variant` and
 * a full override, use a plain <div className={styles.skeleton}>.
 */
export function Skeleton({
  variant = "row",
  width,
  height,
}: SkeletonProps) {
  const style: React.CSSProperties = {};
  if (width !== undefined) style.width = width;
  if (height !== undefined) style.height = height;
  return (
    <span
      role="status"
      aria-live="polite"
      aria-label="Loading"
      className={`${styles.skeleton} ${styles[variant]}`}
      style={style}
    />
  );
}
